import { atom } from '@zedux/react'

const customersListAtom = atom('customersListAtom', []);

export default customersListAtom;